exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".button-control{background:#76caca;color:#fff;height:50px;width:auto;padding:0 50px;border-radius:5px;border:none;box-shadow:0 4px #62bdbd;text-transform:uppercase;font-size:14px;font-weight:600}.button-control:hover{background:#e8645a;box-shadow:0 4px #e2534b}.button-control:active{box-shadow:0 3px #e2534b;transform:translateY(3px)}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-4caaf5f1","scoped":false,"hasInlineConfig":true}!./src/components/button-control/button-control.css
// module id = ./node_modules/css-loader/index.js?minimize!./node_modules/vue-loader/lib/style-compiler/index.js?{"vue":true,"id":"data-v-4caaf5f1","scoped":false,"hasInlineConfig":true}!./src/components/button-control/button-control.css
// module chunks = index